import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { LoadingBarModule } from '@ngx-loading-bar/core';

import { SharedModule } from '../../shared/shared.module';

import {
  InvoiceComponent,
  InvoiceListComponent,
  InvoiceViewComponent
} from './';

@NgModule({
  declarations: [
    InvoiceComponent,
    InvoiceListComponent,
    InvoiceViewComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    SharedModule,
    LoadingBarModule,
    FormsModule,
    ReactiveFormsModule
  ]
})
export class InvoiceModule { }
